module.exports = __webpack_public_path__ + "static/media/bmi_icon.1e290fa7.png";